/**
 * Strips a leading `@`, trims, lowercases the prefix, and uppercases the discriminator.
 * `@JohnDo#k7qm` becomes `johndo#K7QM`.
 */
export function normalizeHandle(value: string): string {
	const trimmed = value.trim().replace(/^@+/, '');
	const hash = trimmed.indexOf('#');

	if (hash < 0) {
		return trimmed.toLowerCase();
	}

	const prefix = trimmed.slice(0, hash).toLowerCase();
	const discriminator = trimmed.slice(hash + 1).toUpperCase();

	return `${prefix}#${discriminator}`;
}
